import { render } from "./IdamSegmentator.vue?vue&type=template&id=4232b0c9"
import script from "./IdamSegmentator.vue?vue&type=script&lang=js"
export * from "./IdamSegmentator.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__